import React from 'react';
import Button from '../../../components/forms/button/Button';
import { setEmailWhitelisted } from '../../../services/maintenance';
import { IGroupMember } from '../../../store/group/groupState';

interface IOwnState {
    isloading: boolean;
}

interface IOwnProps {
    member: IGroupMember;
    deleteFromList: (diNumber: number) => void;
}

type Props = IOwnProps;
type State = IOwnState;

class BouncedEmailListItem extends React.Component<Props, State> {
    constructor(props: IOwnProps) {
        super(props);
        this.state = {
            isloading: false,
        };
    }

    private whitelist = async (e: React.FormEvent<HTMLButtonElement>) => {
        e.preventDefault();

        this.setState({
            isloading: true,
        });

        const email = this.props.member.bounce.email;
        const diNumber = this.props.member.diNumber;

        await setEmailWhitelisted(diNumber, email);

        this.setState({
            isloading: false,
        });

        this.props.deleteFromList(diNumber);
    };

    public render() {
        const { fullName } = this.props.member;
        const { email, timestamp, count } = this.props.member.bounce;

        return (
            <tr>
                <td data-label="Navn">
                    <p>{fullName}</p>
                </td>
                <td data-label="Email">
                    <p>{email}</p>
                </td>
                <td data-label="Dato">
                    <p>{timestamp}</p>
                </td>
                <td data-label="Fejlende leverancer">
                    <p>{count}</p>
                </td>
                <td data-label="">
                    <Button modifierClass="button--primary button--small" type="button" onClick={this.whitelist} spinning={this.state.isloading}>
                        <span className="text">Whitelist</span>
                    </Button>
                </td>
            </tr>
        )
    }
}

export default BouncedEmailListItem;